import React, { useEffect, useState } from 'react';
import { Menu, X, Phone, Clock, MapPin } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Areas',
    href: '#areas'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className="fixed top-0 w-full z-50" data-id="element-274">
      {/* Top Utility Bar */}
      <motion.div initial={false} animate={{
      height: scrolled ? 0 : 'auto',
      opacity: scrolled ? 0 : 1
    }} transition={{
      duration: 0.3
    }} className="bg-navy-900 overflow-hidden" data-id="element-275">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-276">
          <div className="flex items-center justify-between py-2" data-id="element-277">
            <div className="hidden md:flex items-center gap-6" data-id="element-278">
              <div className="flex items-center gap-2 text-gray-400 text-xs tracking-wide" data-id="element-279">
                <MapPin size={12} className="text-gold" data-id="element-280" />
                <span data-id="element-281">Serving All of Pennsylvania</span>
              </div>
              <div className="w-px h-3 bg-white/10" data-id="element-282"></div>
              <div className="flex items-center gap-2 text-gray-400 text-xs tracking-wide" data-id="element-283">
                <Clock size={12} className="text-gold" data-id="element-284" />
                <span data-id="element-285">Mon – Sat: 7AM – 7PM</span>
              </div>
            </div>
            <div className="flex items-center gap-4 ml-auto" data-id="element-286">
              <span className="hidden sm:inline text-gray-400 text-xs tracking-wide" data-id="element-287">
                PA License #934782
              </span>
              <div className="hidden sm:block w-px h-3 bg-white/10" data-id="element-288"></div>
              <a href="tel:2152981345" className="flex items-center gap-2 text-gold hover:text-white transition-colors text-xs font-bold tracking-wider" data-id="element-289">
                <Phone size={12} data-id="element-290" />
                <span data-id="element-291">(215) 298-1345</span>
              </a>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Main Navigation */}
      <nav className={`w-full transition-all duration-500 ${scrolled ? 'bg-navy/98 backdrop-blur-xl shadow-[0_4px_30px_rgba(0,0,0,0.3)]' : 'bg-navy/90 backdrop-blur-sm'}`} data-id="element-292">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293">
          <div className={`flex justify-between items-center transition-all duration-500 ${scrolled ? 'h-16' : 'h-20'}`} data-id="element-294">
            {/* Logo */}
            <div className="flex-shrink-0 flex items-center" data-id="element-295">
              <a href="#" className="flex items-center gap-4 group" data-id="element-296">
                <img src="https://cdn.magicpatterns.com/uploads/mHQYWDhNJXGSPsTWooPTGm/Photoroom_20260425_171611.png" alt="Blue Sky Logo" className={`w-auto object-contain transition-all duration-500 group-hover:scale-105 ${scrolled ? 'h-10' : 'h-14'}`} data-id="element-297" />
                <div className="hidden sm:block" data-id="element-298">
                  <span className="block font-heading font-bold text-xl leading-none tracking-widest text-white" data-id="element-299">
                    BLUE SKY
                  </span>
                  <span className="block text-[9px] uppercase tracking-[0.25em] text-gold/80 mt-1.5 font-medium" data-id="element-300">
                    General Contractor LLC
                  </span>
                </div>
              </a>
            </div>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center" data-id="element-301">
              <div className="flex items-center gap-1" data-id="element-302">
                {navLinks.map(link => <a key={link.name} href={link.href} className="relative px-4 py-2 text-[11px] font-bold uppercase tracking-[0.15em] text-gray-300 hover:text-white transition-all duration-300 group" data-id="element-303">
                    {link.name}
                    <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-px bg-gold transition-all duration-300 group-hover:w-3/4" data-id="element-304"></span>
                  </a>)}
              </div>

              <div className="flex items-center gap-5 ml-8 pl-8 border-l border-white/10" data-id="element-305">
                <a href="tel:2152981345" className="hidden xl:flex items-center gap-2.5 group" data-id="element-306">
                  <div className="w-9 h-9 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center group-hover:bg-gold/20 transition-colors duration-300" data-id="element-307">
                    <Phone size={14} className="text-gold" data-id="element-308" />
                  </div>
                  <div data-id="element-309">
                    <span className="block text-[9px] uppercase tracking-widest text-gray-400 leading-none" data-id="element-310">
                      Call Us
                    </span>
                    <span className="block text-sm font-bold text-white tracking-wide mt-0.5" data-id="element-311">
                      (215) 298-1345
                    </span>
                  </div>
                </a>
                <a href="#contact" className="relative overflow-hidden bg-gold text-navy font-bold px-7 py-3 rounded-sm uppercase text-[10px] tracking-[0.2em] shadow-[0_0_20px_rgba(201,168,76,0.15)] hover:shadow-[0_0_25px_rgba(201,168,76,0.35)] transition-all duration-300 group" data-id="element-312">
                  <span className="relative z-10" data-id="element-313">Free Estimate</span>
                  <div className="absolute inset-0 bg-white/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700" data-id="element-314"></div>
                </a>
              </div>
            </div>

            {/* Tablet Menu (md but not lg) */}
            <div className="hidden md:flex lg:hidden items-center gap-4" data-id="element-315">
              <a href="#contact" className="bg-gold text-navy font-bold px-5 py-2.5 rounded-sm uppercase text-[10px] tracking-[0.2em]" data-id="element-316">
                Free Estimate
              </a>
              <button onClick={() => setIsOpen(!isOpen)} className="text-gray-200 hover:text-white focus:outline-none p-2" data-id="element-317">
                {isOpen ? <X size={24} data-id="element-318" /> : <Menu size={24} data-id="element-319" />}
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden flex items-center gap-3" data-id="element-320">
              <a href="tel:2152981345" className="w-9 h-9 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center" data-id="element-321">
                <Phone size={14} className="text-gold" data-id="element-322" />
              </a>
              <button onClick={() => setIsOpen(!isOpen)} className="text-gray-200 hover:text-white focus:outline-none p-2" data-id="element-323">
                {isOpen ? <X size={22} data-id="element-324" /> : <Menu size={22} data-id="element-325" />}
              </button>
            </div>
          </div>
        </div>

        {/* Gold accent line */}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-326"></div>
      </nav>

      {/* Mobile/Tablet Menu */}
      <AnimatePresence data-id="element-327">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} className="lg:hidden bg-navy/98 backdrop-blur-xl border-t border-white/5 shadow-[0_20px_40px_rgba(0,0,0,0.4)]" data-id="element-328">
            <div className="max-w-7xl mx-auto px-4 pt-4 pb-8" data-id="element-329">
              <div className="space-y-1" data-id="element-330">
                {navLinks.map((link, index) => <motion.a key={link.name} href={link.href} onClick={() => setIsOpen(false)} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: index * 0.05
            }} className="flex items-center gap-4 px-4 py-3.5 text-sm font-bold uppercase tracking-[0.15em] text-gray-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors" data-id="element-331">
                    <div className="w-1 h-1 rounded-full bg-gold/50" data-id="element-332"></div>
                    {link.name}
                  </motion.a>)}
              </div>
              <div className="mt-6 pt-6 border-t border-white/10 space-y-4" data-id="element-333">
                <a href="tel:2152981345" className="flex items-center justify-center gap-3 text-white font-bold py-3 bg-white/5 rounded-lg border border-white/10" data-id="element-334">
                  <Phone size={16} className="text-gold" data-id="element-335" />
                  <span className="tracking-wider" data-id="element-336">(215) 298-1345</span>
                </a>
                <a href="#contact" onClick={() => setIsOpen(false)} className="block text-center bg-gold text-navy font-bold px-6 py-4 rounded-lg uppercase text-xs tracking-[0.2em]" data-id="element-337">
                  Get Free Estimate
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}